import { useMemo } from "react";
import { Option } from "../SelectBase";
/**
 * Custom hook to filter options based on a search string.
 * Returns all options if search is empty, otherwise filters by label or value.
 *
 * @param options - Array of Option objects to filter.
 * @param search - Search string to filter options by.
 * @returns Filtered array of Option objects.
 */
export function useFilteredOptions(options: Option[], search: string) {
  return useMemo(() => {
    if (!search.length) {
      return options;
    }

    const searchItem = search.toLowerCase();
    return options.filter(
      (option) =>
        option.label.toLowerCase().includes(searchItem) ||
        option.value.toLowerCase().includes(searchItem)
    );
  }, [options, search]);
}
